import PropTypes from "prop-types";

function BasketMixMobile({ config }) {
  return (
    <iframe
      width={"100%"}
      height={"100%"}
      src="https://mtrix-basket-mix.mtrix.com.br"
    ></iframe>
  );
}

BasketMixMobile.defaultProps = {
  app: null,
  config: {},
};

BasketMixMobile.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default BasketMixMobile;
